module.exports = __webpack_public_path__ + "img/img (2).447b02ea.jpg";